

































































































// vendor
import { defineComponent, computed, ref, PropType } from "@vue/composition-api";
// project
import { DisplayJSON } from "@/components.generic/display-code";
import { Gallery } from "@/psychlab/types/gallery";
// local
import { default as SourceList } from "./source-list.vue";


export default defineComponent({

	emits:[],
	props:{
		data:{
			type:Object as PropType<Gallery>,
			required:true,
		}
	},
	components:{
		"display-json":DisplayJSON,
		SourceList,
	},
	setup(props){
		
		const settings = computed(() => {
			const cp:any = {};
			Object.keys(props.data)
			.forEach(k => {
				if([ "items" ].indexOf(k) > -1){ return; }
				cp[k] = (props.data as any)[k];

			});
			return cp;
		});
		

		return {
			settings,
		};
	}
});

